<template>
  <div v-sticky class="vg_button_group" style="display: flex; padding-top: 16px; background: white">
    <span v-if="isShow === true">
      <el-button :disabled="!btn.edit" size="small" type="success" @click="openEdit">编辑</el-button>
      <el-button size="small" type="primary" @click="$emit('refresh')">刷新</el-button>
    </span>
    <span v-if="isShow === false">
      <el-button size="small" type="primary" @click="submit(strForm)">保存</el-button>
      <el-button size="small" @click="closeEdit">取消</el-button>
    </span>
    <slot name="functionButton" />
    <div class="flexHV" style="margin-left: auto">
      <slot name="otherButton" />
      <div v-if="!special" class="flexHV">
        <span class="vg_tag_label">状态：</span>
        <el-tag :type="helper.getStatusName(strForm.status).type">{{ helper.getStatusName(strForm.status).name }}</el-tag>
      </div>
      <div v-else class="flexHV">
        <slot name="specialStatus" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'editHeader',
  props: {
    isShow: Boolean,
    special: Boolean,
    btn: Object,
    strForm: { type: Object, default: () => {} }
  },
  methods: {
    openEdit() {
      this.$emit('openEdit');
    },
    closeEdit() {
      this.$emit('closeEdit');
    },
    submit(strForm) {
      this.$emit('submit');
    }
  }
};
</script>

<style lang="scss" scoped></style>
